import React, { useState, useEffect } from "react";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { IoCloseCircleOutline } from "react-icons/io5";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import eye from '../../auth/image/eye.svg';
import eyeslash from "../../auth/image/eyeslash.svg";
import Warning from '../../auth/image/Warning.svg';
import "./styles.scss";
import PropTypes from "prop-types";

const Input = (props) => {
  let {
    label,
    error,
    errorMessage,
    value,
    type,
    "data-testid": dataTestId,
    name,
    placeholder,
    onChange,
    containerClassName,
    labelClassName,
    errorClassName,
    inputClassName,
    autoComplete,
    maxLength,
    disabled,
    onKeyPress,
    customlabelClassName,
    id,
    readOnly,
    showTooltip,
    endIcon,
    tooltipText,
    minDate,
    maxDate,
    checked,
    endIconImage,
    onFocus,
    preventSpaces = false, // New prop to prevent spaces
    preventLeadingSpaces = false, // New prop to prevent leading spaces only
    showPasswordToggle = true, // New prop to control password toggle visibility

  } = props;
  const [inputType, setInputType] = useState(type);

  useEffect(() => {
    setInputType(type);
  }, [type]);

  const handleChange = (e) => {
    let newValue = e.target.value;

    // Prevent all spaces if preventSpaces is true
    if (preventSpaces) {
      newValue = newValue.replace(/\s/g, '');
    }
    // Prevent leading spaces if preventLeadingSpaces is true
    else if (preventLeadingSpaces) {
      newValue = newValue.replace(/^\s+/, '');
    }

    // Call the original onChange with modified value
    if (onChange) {
      // Create a new event-like object or call onChange with modified value
      onChange({
        target: {
          name: e.target.name,
          value: newValue
        }
      });
    }
  };

  const parentClass =
    type == "password" || "Warning"
      ? props.parentDivClassName
        ? props.parentDivClassName
        : "input-wrapper"
      : endIcon === true
        ? "input-wrapper"
        : "";
  inputClassName = error ? " errorInputUpdate form-control errorinput" : inputClassName;

  return (
    <>
      <div
        className={
          containerClassName
            ? containerClassName
            : "frmgroup validate default-input col-6"
        }
        id={id}
      >
        <div className={`frmhead ${labelClassName}`}>
          {label && <label className={customlabelClassName}>{typeof label === 'string' && label.endsWith('*') ? <>{label.slice(0, -1)}<span className="RedHighlight">*</span></> : label}</label>}
          {showTooltip && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="tooltipHeader">{tooltipText}</Tooltip>
              }
            >
              <span>
                <BsFillInfoCircleFill />
              </span>
            </OverlayTrigger>
          )}
          {error && (
            <div className={`error ${errorClassName}`}>{errorMessage}</div>
          )}
        </div>
        <div className={parentClass}>
          <input
            type={inputType}
            name={name}
            value={value}
            data-testid={dataTestId}
            onChange={handleChange}
            placeholder={placeholder}
            className={inputClassName}
            disabled={disabled}
            onKeyPress={onKeyPress}
            checked={checked}
            autoComplete={autoComplete}
            maxLength={maxLength}
            readOnly={readOnly}
            min={minDate}
            max={maxDate}
            onFocus={onFocus}
            style={{
              paddingRight:
                props.showRemoveButton || type == "password" ? "40px" : "auto",
            }}
          />
          {props.showRemoveButton && (
            <a
              className="remove-button-business"
              onClick={() => props.handleRemoveField(props.index)}
            >
              <IoCloseCircleOutline />
            </a>
          )}
          {inputType == "Warning" && (
            <span className="input-warning">
              <img src={Warning} />
            </span>
          )}
          {inputType == "password" && showPasswordToggle && (
            <a
              className="remove-button-business eyeIcon"
              onClick={() => {
                setInputType("text");
              }}
            >
              <img src={eye} />
            </a>
          )}
          {type == "password" && inputType == "text" && showPasswordToggle && (
            <a
              className="remove-button-business eyeIcon"
              onClick={() => setInputType("password")}
            >
              <img src={eyeslash} />
            </a>
          )}
          {endIconImage && (
            endIconImage
          )}
        </div>
      </div>
    </>
  );
};

export default Input;
Input.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  onKeyPress: PropTypes.func,
  customlabelClassName: PropTypes.string,
  id: PropTypes.string,
  readOnly: PropTypes.bool,
  showTooltip: PropTypes.bool,
  endIcon: PropTypes.bool,
  tooltipText: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  endIconImage: PropTypes.node,
  onFocus: PropTypes.func,
  parentDivClassName: PropTypes.string,
  showRemoveButton: PropTypes.bool,
  handleRemoveField: PropTypes.func,
  index: PropTypes.number,
  preventSpaces: PropTypes.bool,
  preventLeadingSpaces: PropTypes.bool,
  showPasswordToggle: PropTypes.bool,
};


